// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/draft.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../google/type/date_pb";
import { file_google_type_date } from "../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/draft.proto.
 */
export const file_v1_draft: GenFile = /*@__PURE__*/
  fileDesc("Cg52MS9kcmFmdC5wcm90bxICdjEiOgoRTGlzdERyYWZ0c1JlcXVlc3QSEQoJcGFnZV9zaXplGAEgASgFEhIKCnBhZ2VfdG9rZW4YAiABKAkiTwoSTGlzdERyYWZ0c1Jlc3BvbnNlEiAKBmRyYWZ0cxgBIAMoCzIQLnYxLkRyYWZ0TWVzc2FnZRIXCg9uZXh0X3BhZ2VfdG9rZW4YAiABKAki8gEKDERyYWZ0TWVzc2FnZRIKCgJpZBgBIAEoBRITCgtjdXN0b21lcl9pZBgCIAEoBRIVCg1jdXN0b21lcl9uYW1lGAMgASgJEg8KB21lc3NhZ2UYBCABKAkSKQoOY2FsY3VsYXRlX2RhdGUYBSABKAsyES5nb29nbGUudHlwZS5EYXRlEg4KBnJlZ2lvbhgGIAEoCRIuCgpjcmVhdGVkX2F0GAcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GAggASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCIdCg9HZXREcmFmdFJlcXVlc3QSCgoCaWQYASABKAUiMwoQR2V0RHJhZnRSZXNwb25zZRIfCgVkcmFmdBgBIAEoCzIQLnYxLkRyYWZ0TWVzc2FnZSIgChJEZWxldGVEcmFmdFJlcXVlc3QSCgoCaWQYASABKAUiNwoTRGVsZXRlRHJhZnRSZXNwb25zZRIPCgdzdWNjZXNzGAEgASgIEg8KB21lc3NhZ2UYAiABKAkywgEKDERyYWZ0U2VydmljZRI7CgpMaXN0RHJhZnRzEhUudjEuTGlzdERyYWZ0c1JlcXVlc3QaFi52MS5MaXN0RHJhZnRzUmVzcG9uc2USNQoIR2V0RHJhZnQSEy52MS5HZXREcmFmdFJlcXVlc3QaFC52MS5HZXREcmFmdFJlc3BvbnNlEj4KC0RlbGV0ZURyYWZ0EhYudjEuRGVsZXRlRHJhZnRSZXF1ZXN0GhcudjEuRGVsZXRlRHJhZnRSZXNwb25zZUIoWiZnaXRodWIuY29tL2R1Y2J0L3R0LWdvL2dlbi9wcm90by92MTt2MWIGcHJvdG8z", [file_google_protobuf_timestamp, file_google_type_date]);

/**
 * ListDraftsRequest is the request for listing drafts
 *
 * @generated from message v1.ListDraftsRequest
 */
export type ListDraftsRequest = Message<"v1.ListDraftsRequest"> & {
  /**
   * Number of drafts to return (default: 50, max: 100)
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * Token for pagination (empty for first page)
   *
   * @generated from field: string page_token = 2;
   */
  pageToken: string;
};

/**
 * Describes the message v1.ListDraftsRequest.
 * Use `create(ListDraftsRequestSchema)` to create a new message.
 */
export const ListDraftsRequestSchema: GenMessage<ListDraftsRequest> = /*@__PURE__*/
  messageDesc(file_v1_draft, 0);

/**
 * ListDraftsResponse contains the list of draft messages
 *
 * @generated from message v1.ListDraftsResponse
 */
export type ListDraftsResponse = Message<"v1.ListDraftsResponse"> & {
  /**
   * @generated from field: repeated v1.DraftMessage drafts = 1;
   */
  drafts: DraftMessage[];

  /**
   * Token for next page (empty if no more pages)
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message v1.ListDraftsResponse.
 * Use `create(ListDraftsResponseSchema)` to create a new message.
 */
export const ListDraftsResponseSchema: GenMessage<ListDraftsResponse> = /*@__PURE__*/
  messageDesc(file_v1_draft, 1);

/**
 * DraftMessage represents a draft message
 *
 * @generated from message v1.DraftMessage
 */
export type DraftMessage = Message<"v1.DraftMessage"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: int32 customer_id = 2;
   */
  customerId: number;

  /**
   * @generated from field: string customer_name = 3;
   */
  customerName: string;

  /**
   * @generated from field: string message = 4;
   */
  message: string;

  /**
   * Date for calculating lottery results
   *
   * @generated from field: google.type.Date calculate_date = 5;
   */
  calculateDate?: Date;

  /**
   * @generated from field: string region = 6;
   */
  region: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * Note: No parse_error field - frontend will re-parse to show errors
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message v1.DraftMessage.
 * Use `create(DraftMessageSchema)` to create a new message.
 */
export const DraftMessageSchema: GenMessage<DraftMessage> = /*@__PURE__*/
  messageDesc(file_v1_draft, 2);

/**
 * GetDraftRequest is the request for getting a single draft
 *
 * @generated from message v1.GetDraftRequest
 */
export type GetDraftRequest = Message<"v1.GetDraftRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message v1.GetDraftRequest.
 * Use `create(GetDraftRequestSchema)` to create a new message.
 */
export const GetDraftRequestSchema: GenMessage<GetDraftRequest> = /*@__PURE__*/
  messageDesc(file_v1_draft, 3);

/**
 * GetDraftResponse contains a single draft message
 *
 * @generated from message v1.GetDraftResponse
 */
export type GetDraftResponse = Message<"v1.GetDraftResponse"> & {
  /**
   * @generated from field: v1.DraftMessage draft = 1;
   */
  draft?: DraftMessage;
};

/**
 * Describes the message v1.GetDraftResponse.
 * Use `create(GetDraftResponseSchema)` to create a new message.
 */
export const GetDraftResponseSchema: GenMessage<GetDraftResponse> = /*@__PURE__*/
  messageDesc(file_v1_draft, 4);

/**
 * DeleteDraftRequest is the request for deleting a draft
 *
 * @generated from message v1.DeleteDraftRequest
 */
export type DeleteDraftRequest = Message<"v1.DeleteDraftRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message v1.DeleteDraftRequest.
 * Use `create(DeleteDraftRequestSchema)` to create a new message.
 */
export const DeleteDraftRequestSchema: GenMessage<DeleteDraftRequest> = /*@__PURE__*/
  messageDesc(file_v1_draft, 5);

/**
 * DeleteDraftResponse is the response after deleting a draft
 *
 * @generated from message v1.DeleteDraftResponse
 */
export type DeleteDraftResponse = Message<"v1.DeleteDraftResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message v1.DeleteDraftResponse.
 * Use `create(DeleteDraftResponseSchema)` to create a new message.
 */
export const DeleteDraftResponseSchema: GenMessage<DeleteDraftResponse> = /*@__PURE__*/
  messageDesc(file_v1_draft, 6);

/**
 * DraftService provides operations for managing draft messages
 *
 * @generated from service v1.DraftService
 */
export const DraftService: GenService<{
  /**
   * ListDrafts returns all draft messages for the authenticated user
   *
   * @generated from rpc v1.DraftService.ListDrafts
   */
  listDrafts: {
    methodKind: "unary";
    input: typeof ListDraftsRequestSchema;
    output: typeof ListDraftsResponseSchema;
  },
  /**
   * GetDraft retrieves a single draft message by ID
   *
   * @generated from rpc v1.DraftService.GetDraft
   */
  getDraft: {
    methodKind: "unary";
    input: typeof GetDraftRequestSchema;
    output: typeof GetDraftResponseSchema;
  },
  /**
   * DeleteDraft deletes a draft message
   *
   * @generated from rpc v1.DraftService.DeleteDraft
   */
  deleteDraft: {
    methodKind: "unary";
    input: typeof DeleteDraftRequestSchema;
    output: typeof DeleteDraftResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_draft, 0);

